import React, { useCallback, useEffect } from 'react';
import { array, bool, func, shape } from 'prop-types';

import { groupBy } from 'lodash';

import useApi from '../../hooks/useApi';
import template from 'url-template';

import TagSelect from '../../components/FormFields/TagSelect';

const SystemTypesUrl = template.parse('/system-types{?limit}');
const LIMIT = 10000;

const SystemsSelectFilter = ({
    disabled,
    systemsFilter,
    onChangeSystemsFilter,
    ...props
}) => {
    const [systems, getSystems] = useApi(() => ({
        url: SystemTypesUrl.expand({
            limit: LIMIT,
        })
    }));

    useEffect(() => {
        getSystems();
        return () => {
            systems.cancel();
        };
    }, []);

    const changeHandler = (defaultValues = {}) => {
        return (event) => {
            const { value } = event.target;
            const groupedValues = groupBy(value, 'type');
            const newValues = { ...defaultValues };
            Object.entries(groupedValues).forEach(([type, value]) => {
                newValues[type] = value;
            });
            onChangeSystemsFilter(newValues);
        };
    };

    const handleChange = useCallback(
        changeHandler({
            systems: []
        })
    );

    const options = [
        {
            error:     systems.error,
            isLoading: systems.loading,
            items:     systems.data,
            name:      'Systems',
            itemProps: {
                type: 'systems'
            }
        }
    ];

    const value = [...systemsFilter.systems];

    return (
        <TagSelect
            disabled={disabled}
            grouped
            kickerText="Add any combination of System Types to filter by these types."
            label="Systems"
            name={undefined}
            onChange={handleChange}
            options={options}
            placeholder="Add System Type"
            value={value}
            {...props}
        />
    );
};

SystemsSelectFilter.defaultProps = {
    systemsFilter: {
        systems: []
    },
    disabled:              false,
    onChangeSystemsFilter: () => {}
};

SystemsSelectFilter.propTypes = {
    systemsFilter: shape({
        systems: array.isRequired
    }),
    disabled:              bool,
    onChangeSystemsFilter: func.isRequired
};

export default SystemsSelectFilter;
